import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import { Form, Message, Grid, Header } from 'semantic-ui-react'
// import Promise from 'promise-polyfill'
import 'whatwg-fetch'

class ContactForm extends Component {
  static propTypes = {
    previewName: PropTypes.string.isRequired,
  }

  constructor (props) {
    super(props)
    this.state = {
      email: '',
      name: '',
      message: '',
      success: false,
      errors: [],
    }
  }

  handleChange (e, {name, value}) {
    // console.log(name, value)
    this.setState({
      [name]: value,
    })
  }

  handleSubmit (event) {
    const formData  = new FormData();

    const body = {
      ftrp: '',
      hash: process.env.REACT_APP_FORM_HASH,
      name: this.state.name,
      email: this.state.email,
      message: this.state.message,
      template: this.props.previewName
    }

    for(var name in body) {
      formData.append(name, body[name]);
    }

    fetch('https://forms.ron.gr/cors.php', {
      method: 'POST',
      mode: 'cors',
      headers: {},
      body: formData
    }).then(res => res.json())
    .then((result) => {
      // console.log('Result', result)
      if (result.error_fields && result.error_fields.length) {
        this.setState({
          success: false,
          errors: [result.status_msg],
        })
      } else {
        this.setState({
          email: '',
          name: '',
          message: '',
          success: true,
          errors: [],
        })
      }
    },
    (error) => {
      this.setState({
        success: false,
        errors: [error],
      })
    })
  }

  render () {
    // console.log(this.state)
    const {email, name, message, success, errors} = this.state
    const {t} = this.props

    return (
      <Grid centered columns={2}>
        <Grid.Row>
          <Grid.Column mobile={16} tablet={8} computer={8}>
            <Header>{t('WebsiteFormHeader')}</Header>
            <p>{t('WebsiteFormParagraph')}</p><br/>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={8} computer={8}>
            <Form
              id="website-form"
              data-type="rcform"
              onSubmit={this.handleSubmit.bind(this)}>
              <Form.Input
                placeholder={t('Your email addess')}
                type="email"
                name="email"
                label={t('Email')}
                value={email}
                onChange={this.handleChange.bind(this)}
                required
              />
              <Form.Input
                placeholder={t('Your full name')}
                name="name"
                label={t('Name')}
                value={name}
                onChange={this.handleChange.bind(this)}
                required
              />
              <Form.TextArea
                placeholder={t('A few words about your project')}
                name="message"
                label={t('Description')}
                value={message}
                onChange={this.handleChange.bind(this)}
              />
              {!!errors.length &&
                <Message
                  negative
                  header={t('Message NOT delivered')}
                  content={errors.join(' ')}
                />}
              {success &&
                <Message
                  positive
                  header={t('Message was submitted')}
                  content={t('Thank you!')}
                />}
            </Form>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

export default translate('tr')(ContactForm)



// WEBPACK FOOTER //
// ./src/components/ContactForm.jsx